<template lang="pug">
div.datacenter
  RadioGroup(v-model="staRadio" type="button",@on-change="changeRadio").RadioGroup
    Radio(label='学习资料')
    Radio(label='专业名词')
    Radio(label='网络链接')
  div(v-show="staRadio=='学习资料'",style="margin-top: 20px")
    Table(:columns="columns1" :data="learndata",@on-selection-change="handleSelectionChange",ref="selection1")
    Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords"
         :page-size="10" :current="pageData.pageNo" show-elevator)
    div.dataNumber 当前页面共有{{currentlength}}条数据，共有{{pageData.totalRecords}}条数据
    Modal(v-model="modal1" title="上传学习资料" width="500",:footer-hide="true")
      Form(ref="learn",:model="ruleForm",:rules="rules")
        FormItem(label="排序")
          InputNumber(v-model="ruleForm.seq",:min=1,size="large")
        FormItem(label="标题",prop="title")
          Input(type="text",v-model="ruleForm.title")
        formItem(label="资料简介",prop="description")
          Input(type="textarea",resize="none",:rows=3,v-model="ruleForm.description",size="small")
        Form-item(label="学习资料：")
          Upload(ref="upload",class="upload-demo",
            :headers="headersToken"
            :data="{seq:ruleForm.seq,code:userCode,title:ruleForm.title,description:ruleForm.description}"
            ,action="./api/updateFile",
            :show-upload-list="false",multiple:limit="1",:default-file-list="fileList",:before-upload="beforeAvatarUpload",:on-success="aftersuccess",:on-error="afterError")
            Button(size="large") 上传文件
            div(slot="tip",class="el-upload__tip") 可以上传word、excel、ppt、pdf、txt等文件，且不超过20MB
          div(v-if="file !== null") {{ file.name }}
          Button(style="margin-left: 10px;float:right" type="success",
            @click="submitUpload") 确认上传
    Modal(v-model="modal2" title="修改学习资料" width="500" @on-ok="editorlearn")
      Form(ref="learn2",:model="ruleForm",:rules="rules")
        FormItem(label="排序")
          InputNumber(v-model="ruleForm.seq",:min=1,size="large")
        FormItem(label="标题",prop="title")
          Input(type="text",v-model="ruleForm.title")
        FormItem(label="资料简介",prop="description")
          Input(type="textarea",resize="none",:rows=3,v-model="ruleForm.description",size="small")
    Modal(v-model="modal7" title="共享" width="520px" @on-ok="share()").shareForTeacher
      div.addTeacherstitle 选择用户:
      iSelectSearch(
        ref='iSelectSearch'
        :optionList='teacherlist',
        @change='selectChange'
        @inputChange='searchChange'
        )
      //- // 既然没这功能咱们就自己造一个嘛
      //- div.addTeachers
      //-   // 这里是外框的上半部分
      //-   div.inputBlock(@click="addTeachers = !addTeachers")
      //-     div.tagBox
      //-       // 最后一步,贴tag
      //-       div
      //-         span.noSelect(v-if="teacherSelect.length === 0") 请选择
      //-         Tag(v-for="(item, index) in teacherSelect" closable :key="index" @on-close="delSelect(index)") {{teacherSelectName[index]}}
      //-     Icon.openDown(:type="addTeachers === true?'ios-arrow-up':'ios-arrow-down'" )
      //-   // 这里是点开的部分
      //-   div.teachersList(v-if="addTeachers === true")
      //-     ul.dropDownList
      //-       li.listChild(@click="allIn()" style="border-bottom:1px solid #F3F3F4")
      //-         span.ListName(:class="allInCheck === true? 'checkThisTeacher':''") 全选
      //-         Icon.current(:class="allInCheck === true? 'checkThisTeacher':''" type="md-checkmark")
      //-       li.listChild(v-for="item in teacherlist" @click="chooseShareTeacher(item)" v-if="item.code !== $role.code")
      //-         span.ListName(:class="teacherSelect.indexOf(item.code) === -1 ? '' : 'checkThisTeacher' ") {{item.name}}
      //-         Icon.current(:class="teacherSelect.indexOf(item.code) === -1 ? '' : 'checkThisTeacher' " type="md-checkmark")
      //- div.mask(v-show="addTeachers === true" @click="closeInput()")
    Button(type="primary",style="margin-top: 20px",@click="uploadlearn",size="large") 新建
    Button(type="primary",style="margin:20px 0 0 10px",size="large",@click="downloadfiledx" v-if="multipleSelection.length > 0") 导出
    Button(type="primary",style="margin:20px 10px 0 10px",size="large",@click="open7('ziliao')",v-if="multipleSelection.length > 0") 分享
    Button(type="primary",style="margin-top: 20px",size="large",@click="confirmlearn" v-if="multipleSelection.length > 0") 删除
    //- span(style="font-family:MicrosoftYaHeiUI;color:rgba(153,153,153,1);line-height:32px;height:32px;margin:20px 0 0 430px;display:inline-block") 当前页面{{}}条数据共有几天书籍
  div(v-show="staRadio=='专业名词'",style="margin-top: 20px")
    Table(:columns="columns2" :data="learnnoun",@on-selection-change="handleSelectionChange",ref="selection2")
    Page.page(@on-change="handleCurrentChange2" :total="pageData2.totalRecords"
         :page-size="10" :current="pageData2.pageNo" show-elevator)
    div.dataNumber 当前页面共有{{nounlength}}条数据，共有{{pageData2.totalRecords}}条数据
    Modal(v-model="modal3" title="添加名词" width="500",@on-ok="createNoun")
      Form(ref="noun",:model="ruleForm2",:rules="rules2")
        FormItem(label="排序")
          InputNumber(v-model="ruleForm2.seq",:min=1,size="large")
        FormItem(label="名词",prop="noun")
          Input(type="text",v-model="ruleForm2.noun")
        formItem(label="解释",prop="content")
          Input(type="textarea",resize="none",:rows=3,v-model="ruleForm2.content",size="small")
    Modal(v-model="modal4" title="添加名词" width="500",@on-ok="editorNoun")
      Form(ref="noun",:model="ruleForm2",:rules="rules2")
        FormItem(label="排序")
          InputNumber(v-model="ruleForm2.seq",:min=1,size="large")
        FormItem(label="名词",prop="noun")
          Input(type="text",v-model="ruleForm2.noun")
        formItem(label="解释",prop="content")
          Input(type="textarea",resize="none",:rows=3,v-model="ruleForm2.content",size="small")
    Button(type="primary",style="margin:20px 10px 0 10px",size="large",@click="addnoun") 创建
    Button(type="primary",style="margin:20px 10px 0 0",size="large",@click="open7('noun')",v-if="multipleSelection.length > 0") 分享
    Button(type="primary",style="margin-top: 20px",size="large",@click="confirmNoun" v-if="multipleSelection.length > 0") 删除
  div(v-show="staRadio=='网络链接'",style="margin-top: 20px")
    Table(:columns="columns3" :data="learnlink",@on-selection-change="handleSelectionChange",ref="selection3")
    Page.page(@on-change="handleCurrentChange3" :total="pageData3.totalRecords"
         :page-size="10" :current="pageData3.pageNo" show-elevator)
    div.dataNumber 当前页面共有{{linklength}}条数据，共有{{pageData3.totalRecords}}条数据
    Modal(v-model="modal5" title="添加链接" width="500",@on-ok="createlink")
      Form(ref="link",:model="ruleForm3",:rules="rules3")
        FormItem(label="排序")
          InputNumber(v-model="ruleForm3.seq",:min=1,size="large")
        FormItem(label="标题",prop="title")
          Input(type="text",v-model="ruleForm3.title")
        formItem(label="链接",prop="link")
          Input(type="text",v-model="ruleForm3.link")
    Modal(v-model="modal6" title="修改链接" width="500",@on-ok="editorLink")
      Form(ref="link",:model="ruleForm3",:rules="rules3")
        FormItem(label="排序")
          InputNumber(v-model="ruleForm3.seq",:min=1,size="large")
        FormItem(label="标题",prop="title")
          Input(type="text",v-model="ruleForm3.title")
        formItem(label="链接",prop="link")
          Input(type="text",v-model="ruleForm3.link")
    Button(type="primary",style="margin:20px 10px 0 10px",size="large",@click="addlink") 创建
    Button(type="primary",style="margin:20px 10px 0 0",size="large",@click="open7('link')",v-if="multipleSelection.length > 0") 分享
    Button(type="primary",style="margin-top: 20px",size="large",@click="confirmLink" v-if="multipleSelection.length > 0") 删除
    // 专业名词显示
    Modal(v-model="learnnounSta",:title="learnnounData.title",:footer-hide="true",@on-visible-change="value=>{if(!value){learnnounData = {title:'',content:''} }}")
      div(style="max-height: 240px;overflow: auto;font-size:14px;") {{learnnounData.content}}
</template>
<script>
import iSelectSearch from "@/components/common/iSelectSearch.vue"; /** 自定义下拉框 */
import dayjs from "dayjs";
export default {
  components: {
    iSelectSearch
  },
  data() {
    return {
      addTeachers: false,
      allInCheck: false,
      totallink: 0,
      totalLearn: 0,
      totalnoun: 0,
      currentlength: 0,
      linklength: 0,
      nounlength: 0,
      headersToken: {
        token: sessionStorage.getItem("tokenTest")
      },
      sharetype: "",
      sharelink: [],
      sharenoun: [],
      sharedata: [],
      teacherSelect: [],
      teacherSelectName: [],
      teacherlist: [],
      pageData: {}, // 表格分页数据
      pageData2: {},
      pageData3: {},
      learnnounData: {
        title: "",
        content: ""
      }, // 显示的专业名词内容\
      learnnounSta: false,
      page: 1,
      file: null,
      id: "",
      multipleSelection: [],
      fileList: [],
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      modal5: false,
      modal6: false,
      modal7: false,
      userCode: this.$role.code,
      staRadio: "学习资料",
      learndata: [], // 学习资料列表
      learnnoun: [], // 专业名词列表
      learnlink: [], // 网络连接列表
      columns1: [
        {
          type: "selection",
          width: 56,
          align: "center"
        },
        {
          title: "序号",
          align: "left",
          render: (h, params) => {
            return h(
              "p",
              {
                props: {
                  content: params.row.userName,
                  placement: "top"
                }
              },
              params.index + 1
            );
          }
        },
        {
          title: "标题",
          key: "title",
          ellipsis: true,
          width: 172
        },
        {
          title: "资料介绍",
          key: "description",
          ellipsis: true
        },
        {
          title: "所有者",
          key: "createUserId",
          width: "116",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          render: (h, params) => {
            return h(
              "Tooltip",
              {
                props: {
                  content: params.row.userName,
                  placement: "top"
                }
              },
              params.row.userCode
            );
          }
        },
        {
          title: "上传时间",
          key: "createdTime",
          width: 180,
          render: (h, params) => {
            return h(
              "p",
              {},
              dayjs(params.row.createdTime).format("YYYY-MM-DD HH:mm:ss")
            );
          }
        },
        {
          title: "操作",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h("span", [
                h("i", {
                  class: "icon-bianji4 iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:10px;cursor:pointer",
                    on: {
                      click: () => {
                        this.show2(params.row);
                      }
                    }
                  },
                  "编辑"
                )
              ]),
              h(
                "i",
                {
                  style: "padding-right:10px;color:#D8D8D8;"
                },
                "|"
              ),
              h("span", [
                h("i", {
                  class: "icon-daochu2 iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:10px;cursor:pointer",
                    on: {
                      click: () => {
                        this.downloadFile(params.row.fileUri);
                      }
                    }
                  },
                  "导出"
                )
              ]),
              h(
                "i",
                {
                  style: "padding-right:10px;color:#D8D8D8;"
                },
                "|"
              ),
              h("span", [
                h("i", {
                  class: "icon-fenxiang1 iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:10px;cursor:pointer",
                    on: {
                      click: () => {
                        this.modal7 = true;
                        this.sharetype = "studydata";
                        this.sharedata.push(params.row.id);
                        // console.log(params.row);
                      }
                    }
                  },
                  "分享"
                )
              ]),
              h(
                "i",
                {
                  style: "padding-right:10px;color:#D8D8D8;"
                },
                "|"
              ),
              h("span", [
                h("i", {
                  class: "icon-shanchulaji iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:10px;cursor:pointer",
                    on: {
                      click: () => {
                        this.confirm(params.row);
                      }
                    }
                  },
                  "删除"
                )
              ])
            ]);
          }
        }
        // {
        //   title: "导出",
        //   render: (h, params) => {
        //     return h("div", [
        //       h("i", {
        //         class: "icon-daochu iconfont",
        //         fixed: "center",
        //         style: "font-size:20px",
        //         on: {
        //           click: () => {
        //             //
        //             this.downloadFile(params.row.fileUri);
        //           }
        //         }
        //       })
        //     ]);
        //   }
        // },
        // {
        //   title: "删除",
        //   render: (h, params) => {
        //     return h("div", [
        //       h("i", {
        //         class: "icon-shanchu iconfont",
        //         fixed: "center",
        //         style: "font-size:20px",
        //         on: {
        //           click: () => {
        //             this.confirm(params.row);
        //           }
        //         }
        //       })
        //     ]);
        //   }
        // }
      ],
      columns2: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "序号",
          width: 90,
          align: "left",
          render: (h, params) => {
            return h(
              "p",
              {
                props: {
                  content: params.row.userName,
                  placement: "top"
                }
              },
              params.index + 1
            );
          }
        },
        {
          title: "名词",
          key: "noun",
          ellipsis: true,
          width: 172
        },
        {
          title: "解释",
          key: "content",
          ellipsis: true,
          width: 574,
          render: (h, params) => {
            return h("div", [
              h(
                "div",
                {
                  on: {
                    click: () => {
                      // this.confirmcontent(params.row);
                      this.learnnounData.title = params.row.noun;
                      this.learnnounData.content = params.row.content;
                      this.learnnounSta = true;
                    }
                  },
                  style: {
                    cursor: "pointer",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: "#2d8cf0"
                  }
                },
                params.row.content
              )
            ]);
          }
        },
        {
          title: "所有者",
          key: "createUserId",
          width: "116",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          render: (h, params) => {
            return h(
              "Tooltip",
              {
                props: {
                  content: params.row.userName,
                  placement: "top"
                }
              },
              params.row.userCode
            );
          }
        },
        {
          title: "操作",
          width: 250,
          render: (h, params) => {
            return h("div", [
              h("span", [
                h("i", {
                  class: "icon-bianji4 iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:12px;cursor:pointer",
                    on: {
                      click: () => {
                        this.show3(params.row);
                      }
                    }
                  },
                  "编辑"
                )
              ]),
              h(
                "i",
                {
                  style: "padding-right:12px;color:#D8D8D8;"
                },
                "|"
              ),
              h("span", [
                h("i", {
                  class: "icon-fenxiang1 iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:12px;cursor:pointer",
                    on: {
                      click: () => {
                        this.modal7 = true;
                        this.sharetype = "noun";
                        this.sharenoun.push(params.row.id);
                        // console.log(params.row);
                      }
                    }
                  },
                  "分享"
                )
              ]),
              h(
                "i",
                {
                  style: "padding-right:12px;color:#D8D8D8;"
                },
                "|"
              ),
              h("span", [
                h("i", {
                  class: "icon-shanchulaji iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:12px;cursor:pointer",
                    on: {
                      click: () => {
                        this.confirm2(params.row);
                      }
                    }
                  },
                  "删除"
                )
              ])
            ]);
          }
        }
      ],
      columns3: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "序号",
          align: "left",
          width: 90,
          render: (h, params) => {
            return h(
              "p",
              {
                props: {
                  content: params.row.userName,
                  placement: "top"
                }
              },
              params.index + 1
            );
          }
        },
        {
          title: "标题",
          key: "title",
          ellipsis: true,
          width: 172
        },
        {
          title: "链接",
          key: "link",
          ellipsis: true,
          width: 574,
          render: (h, params) => {
            const url = `${params.row.link}`;
            return h(
              "a",
              {
                attrs: {
                  href: url,
                  target: "_black"
                },
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }
              },
              params.row.link
            );
          }
        },
        {
          title: "所有者",
          key: "createUserId",
          width: "116",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          render: (h, params) => {
            return h(
              "Tooltip",
              {
                props: {
                  content: params.row.userName,
                  placement: "top"
                }
              },
              params.row.userCode
            );
          }
        },
        {
          title: "操作",
          width: 250,
          render: (h, params) => {
            return h("div", [
              h("span", [
                h("i", {
                  class: "icon-bianji4 iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:12px;cursor:pointer",
                    on: {
                      click: () => {
                        this.show4(params.row);
                      }
                    }
                  },
                  "编辑"
                )
              ]),
              h(
                "i",
                {
                  style: "padding-right:12px;color:#D8D8D8;"
                },
                "|"
              ),
              h("span", [
                h("i", {
                  class: "icon-fenxiang1 iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:12px;cursor:pointer",
                    on: {
                      click: () => {
                        this.modal7 = true;
                        this.sharetype = "link";
                        this.sharelink.push(params.row.id);
                        // console.log(params.row);
                      }
                    }
                  },
                  "分享"
                )
              ]),
              h(
                "i",
                {
                  style: "padding-right:12px;color:#D8D8D8;"
                },
                "|"
              ),
              h("span", [
                h("i", {
                  class: "icon-shanchulaji iconfont",
                  style: "font-size:16px;color:#4A90E2"
                }),
                h(
                  "span",
                  {
                    style:
                      "cursor:point;font-size:14px;color:#3A76D2;margin-right:12px;cursor:pointer",
                    on: {
                      click: () => {
                        this.confirm3(params.row);
                      }
                    }
                  },
                  "删除"
                )
              ])
            ]);
          }
        }
      ],
      ruleForm: {
        description: "",
        title: "",
        seq: 1
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        description: [
          { required: true, message: "请输入资料简介", trigger: "blur" }
        ]
      },
      // columns2: [
      //   {
      //     type: "selection",
      //     width: 60,
      //     align: "center"
      //   },
      //   {
      //     title: "序号",
      //     type: "index"
      //   },
      //   {
      //     title: "名词",
      //     key: "noun",
      //     ellipsis: true
      //   },
      //   {
      //     title: "内容",
      //     key: "content",
      //     ellipsis: true,
      //     render: (h, params) => {
      //       return h("div", [
      //         h(
      //           "div",
      //           {
      //             on: {
      //               click: () => {
      //                 this.confirmcontent(params.row);
      //               }
      //             },
      //             style: {
      //               cursor: "pointer",
      //               color: "#2d8cf0"
      //             }
      //           },
      //           params.row.content
      //         )
      //       ]);
      //     }
      //   },
      //   {
      //     title: "创建者",
      //     key: "userCode"
      //   },
      //   {
      //     title: "编辑",
      //     render: (h, params) => {
      //       return h("div", [
      //         h("i", {
      //           class: "icon-bianji iconfont",
      //           fixed: "center",
      //           style: "font-size:20px",
      //           on: {
      //             click: () => {
      //               //
      //               this.show3(params.row);
      //             }
      //           }
      //         })
      //       ]);
      //     }
      //   },
      //   {
      //     title: "删除",
      //     render: (h, params) => {
      //       return h("div", [
      //         h("i", {
      //           class: "icon-shanchu iconfont",
      //           fixed: "center",
      //           style: "font-size:20px",
      //           on: {
      //             click: () => {
      //               this.confirm2(params.row);
      //             }
      //           }
      //         })
      //       ]);
      //     }
      //   }
      // ],
      ruleForm2: {
        content: "",
        noun: "",
        seq: 1
      },
      rules2: {
        noun: [{ required: true, message: "请输入名词", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }]
      },
      // columns3: [
      //   {
      //     type: "selection",
      //     width: 60,
      //     align: "center"
      //   },
      //   {
      //     title: "序号",
      //     type: "index"
      //   },
      //   {
      //     title: "标题",
      //     key: "title",
      //     ellipsis: true
      //   },
      //   {
      //     title: "链接",
      //     key: "link",
      //     ellipsis: true,
      //     render: (h, params) => {
      //       const url = `${params.row.link}`;
      //       return h(
      //         "a",
      //         {
      //           attrs: {
      //             href: url,
      //             target: "_black"
      //           }
      //         },
      //         params.row.link
      //       );
      //     }
      //   },
      //   {
      //     title: "创建者",
      //     key: "userCode"
      //   },
      //   {
      //     title: "编辑",
      //     render: (h, params) => {
      //       return h("div", [
      //         h("i", {
      //           class: "icon-bianji iconfont",
      //           fixed: "center",
      //           style: "font-size:20px",
      //           on: {
      //             click: () => {
      //               //
      //               this.show4(params.row);
      //             }
      //           }
      //         })
      //       ]);
      //     }
      //   },
      //   {
      //     title: "删除",
      //     render: (h, params) => {
      //       return h("div", [
      //         h("i", {
      //           class: "icon-shanchu iconfont",
      //           fixed: "center",
      //           style: "font-size:20px",
      //           on: {
      //             click: () => {
      //               this.confirm3(params.row);
      //               // this.confirm2(params.row);
      //             }
      //           }
      //         })
      //       ]);
      //     }
      //   }
      // ],
      rules3: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        link: [{ required: true, message: "请输入链接", trigger: "blur" }]
      },
      ruleForm3: {
        title: "",
        link: "",
        seq: 1
      }
    };
  },
  methods: {
    /** iSelectSearch组件 */
    selectChange(childData) {
      this.teacherSelect = childData.selectKeys;
      this.teacherSelectName = childData.selectNames;
    },
    /** iSelectSearch组件 */
    searchChange(childData) {
      this.getTeacherlist({ name: childData || "" });
    },
    changeRadio() {
      this.$refs.selection1.selectAll(false);
      this.$refs.selection2.selectAll(false);
      this.$refs.selection3.selectAll(false);
    },
    learnlistlength() {
      // 学习资料列表总长度
      const data = {
        userId: this.$role.code
      };
      this.$http.learndata(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.totalLearn = res.data.data.list.length;
          }
        }
      });
    },
    afterError(ev) {
      console.sun(ev);
      this.$Message.error(ev.message);
    },
    linklistlength() {
      // 学习链接总长
      const data = {
        userId: this.$role.code
      };
      this.$http.LinkList(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.totallink = res.data.data.list.length;
          }
        }
      });
    },
    nounlistlength() {
      // 学习名词总长
      const data = {
        userId: this.$role.code
      };
      this.$http.NounList(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.totalnoun = res.data.data.list.length;
          }
        }
      });
    },
    open7(val) {
      // 修改了三个都往sharedata里面传的问题
      if (val === "ziliao") {
        this.sharetype = "studydata";
        this.multipleSelection.forEach(item => {
          this.sharedata.push(item.id);
        });
        this.modal7 = true;
      } else if (val === "noun") {
        this.sharetype = "noun";
        this.multipleSelection.forEach(item => {
          this.sharenoun.push(item.id);
        });
        this.modal7 = true;
      } else if (val === "link") {
        this.sharetype = "link";
        this.multipleSelection.forEach(item => {
          this.sharelink.push(item.id);
        });
        this.modal7 = true;
      }
      console.log(val);
      console.log(this);
    },
    share() {
      // 分享资料
      this.multipleSelection = [];
      if (this.sharetype === "studydata") {
        const data = {
          ids: JSON.stringify(this.sharedata),
          toUsers: JSON.stringify(this.teacherSelect)
        };
        this.$http.shareMaterialToUsers(data).then(res => {
          if (res.data.success) {
            // console.log(res.data.data);
            this.teacherSelect = [];
            this.$Message.success("分享成功");
            this.sharedata = [];
          } else {
            this.$Message.success(res.data.data);
            this.teacherSelect = [];
          }
          console.log(this);
          console.log(res);
        });
      } else if (this.sharetype === "noun") {
        const data1 = {
          ids: JSON.stringify(this.sharenoun),
          toUsers: JSON.stringify(this.teacherSelect)
        };
        this.$http.shareProfessionalTermToUser(data1).then(res => {
          if (res.data.success) {
            // console.log(res.data.data);
            this.$Message.success("分享成功");
            this.teacherSelect = [];
            this.sharenoun = [];
          } else {
            this.$Message.success(res.data.data);
            this.teacherSelect = [];
          }
          console.log(this);
          console.log(res);
        });
      } else if (this.sharetype === "link") {
        const data2 = {
          ids: JSON.stringify(this.sharelink),
          toUsers: JSON.stringify(this.teacherSelect)
        };
        this.$http.shareWebLinkToUser(data2).then(res => {
          console.log(this);
          console.log(res);
          if (res.data.success) {
            // console.log(res.data.data);
            this.teacherSelect = [];
            this.$Message.success("分享成功");
            this.sharelink = [];
          } else {
            this.$Message.success(res.data.data);
            this.teacherSelect = [];
          }
          console.log(this);
          console.log(res);
        });
      }
    },
    uploadlearn() {
      this.ruleForm = {
        description: "",
        title: "",
        seq: 1
      };
      this.file = null;
      this.$forceUpdate();
      this.modal1 = true;
    },
    addnoun() {
      this.ruleForm2 = {
        content: "",
        noun: "",
        seq: 1
      };
      this.$forceUpdate();
      this.modal3 = true;
    },
    handleCurrentChange(page) {
      // 分页函数
      this.learnlist(page);
    },
    handleCurrentChange2(page) {
      // 分页函数
      this.NounList(page);
    },
    handleCurrentChange3(page) {
      // 分页函数
      this.LinkList(page);
    },
    show2(row) {
      this.ruleForm = {
        description: row.description,
        title: row.title,
        seq: row.seq
      };
      this.id = row.id;
      this.modal2 = true;
    },
    editorlearn() {
      // 修改学习资料
      this.$refs.learn2.validate(valid => {
        if (valid) {
          const data = {
            description: this.ruleForm.description,
            title: this.ruleForm.title,
            seq: this.ruleForm.seq,
            id: this.id
          };
          this.$http.editorlearn(data).then(res => {
            if (res.data.success) {
              this.$Message.success("修改成功");
              this.learnlist(1);
            }
          });
        } else {
          this.$Message.error("请填写");
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      // 多选操作
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    downloadFile(url, fileName) {
      // 下载单个文件
      const a = document.createElement("a");
      a.href = url;
      console.log("🚀 ~ downloadFile ~ url:", url);
      if (fileName) {
        a.download = fileName;
      } else {
        a.download = "";
      }
      a.click();
    },
    downloadfiledx() {
      console.log(this.multipleSelection.length);
      if (this.multipleSelection.length === 0) {
        return this.$Message.error("暂无可导出资料");
      }
      // 打包下载文件
      const data = {
        ids: []
      };
      for (let e = 0; e < this.multipleSelection.length; e++) {
        data.ids.push(this.multipleSelection[e].id);
      }
      data.ids = JSON.stringify(data.ids);
      this.$http.downLoadZipFile(data).then(res => {
        // if (res.data.success) {
        console.log("🚀 ~ this.$http.downLoadZipFile ~ res.data:", res.data);
        this.downloadFile(res.data.data, "批量下载.zip");
        this.$Message.success("正在下载");
        // }
      });
    },
    confirmlearn() {
      if (this.multipleSelection.length === 0) {
        this.$Message.warning("请选择要删除的资料");
        return;
      }
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除该资料？",
        content: "<p>删除后学生也将无法查看和导出。</p>",
        onOk: () => {
          this.deletelearnx();
        }
      });
    },
    deletelearnx() {
      // 删除多个选项
      const data = {
        ids: []
      };
      for (let e = 0; e < this.multipleSelection.length; e++) {
        data.ids.push(this.multipleSelection[e].id);
      }
      if (data.ids.length > 0) {
        data.ids = JSON.stringify(data.ids);
        this.$http.deletelearn(data).then(res => {
          if (res.data.success) {
            this.$Message.success("删除成功");
            this.learnlist1(1);
          }
        });
      } else {
        this.$Message.warning("请选择");
      }
    },
    deletlearn(row) {
      // 删除班级列表数据（单个）
      const data = {
        ids: []
      };
      data.ids.push(row.id);
      data.ids = JSON.stringify(data.ids);
      //
      this.$http.deletelearn(data).then(res => {
        if (res.data.success) {
          this.learnlist1(1);
        }
      });
    },
    confirm(row) {
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除该资料？",
        content: "<p>删除后学生也将无法查看和导出。</p>",
        onOk: () => {
          this.deletlearn(row);
        }
      });
    },
    aftersuccess(val) {
      console.sun(val);
      if (!val.success) {
      this.$Message.error(val.message);
      return;
      }
      this.learnlist(1);
      this.modal1 = false;
    },
    beforeAvatarUpload(file) {
      // 点击上传
      this.file = file;
      const fileSize = file.size / 1024 / 1024 <= 20;
      if (!fileSize) {
        this.$Message.error("上传文件大小不能超过 20MB!");
      }
      return false;
    },
    submitUpload() {
      this.$refs.learn.validate(valid => {
        if (valid) {
          if (this.file === null) {
            this.$Message.warning("请上传文件！");
            return;
          }
          this.$refs.upload.post(this.file);
          // this.$Message.success("上传成功");
          this.learnlist(1);
        } else {
          return false;
        }
      });
      this.$forceUpdate();
    },
    learnlist(x) {
      // 学习资料列表
      const data = {
        pageSize: 10,
        pageNo: x,
        userId: this.$role.code
      };
      this.$http.learndata(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.learndata = res.data.data.list;
            console.log(res.data.data.list, "sdsdsds");
          }
          this.pageData = res.data.data;
          this.currentlength = res.data.data.list.length;
        }
      });
    },
    learnlist1(x) {
      // 学习资料列表
      const data = {
        pageSize: 10,
        pageNo: x,
        userId: this.$role.code
      };
      this.$http.learndata(data).then(res => {
        if (res.data.success) {
          this.learndata = res.data.data.list;
          this.currentlength = res.data.data.list.length;
          this.pageData = res.data.data;
        }
      });
    },
    createNoun() {
      // 添加专业名词
      this.$refs.noun.validate(valid => {
        if (valid) {
          const data = {
            content: this.ruleForm2.content,
            noun: this.ruleForm2.noun,
            seq: this.ruleForm2.seq,
            userCode: this.userCode
          };
          this.$http.createOrEditorNoun(data).then(res => {
            if (res.data.success) {
              this.$Message.success("创建成功");
              this.ruleForm2 = {
                content: "",
                noun: "",
                seq: 1
              };
              this.$forceUpdate();
              this.NounList();
            }
          });
        } else {
          this.$Message.error("请填写");
        }
      });
    },
    NounList(x) {
      // 查询专业名词
      const pageNo = x || 1;
      const data = {
        pageSize: 10,
        pageNo,
        userId: this.$role.code
      };
      this.$http.NounList(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.learnnoun = res.data.data.list;
            this.nounlength = res.data.data.list.length;
            console.log(res.data.data.list);
          }
          this.pageData2 = res.data.data;
          //
        }
      });
    },
    NounList1(x) {
      // 查询专业名词
      const pageNo = x || 1;
      const data = {
        pageSize: 10,
        pageNo,
        userId: this.$role.code
      };
      this.$http.NounList(data).then(res => {
        if (res.data.success) {
          this.learnnoun = res.data.data.list;
          this.nounlength = res.data.data.list.length;
          this.pageData2 = res.data.data;
          //
        }
      });
    },
    confirm2(row) {
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除该资料？",
        content: "<p>删除后学生也将无法查看和导出。</p>",
        onOk: () => {
          this.deletenoun(row);
        }
      });
    },
    confirmcontent(row) {
      // 弹出确定内容模态框
      this.$Modal({
        title: row.noun,
        content: row.content
      });
    },
    deletenoun(row) {
      // 删除专业名词数据（单个）
      const data = {
        ids: []
      };
      data.ids.push(row.id);
      data.ids = JSON.stringify(data.ids);
      //
      this.$http.deleteNoun(data).then(res => {
        if (res.data.success) {
          this.NounList1();
        }
      });
    },
    confirmNoun() {
      if (this.multipleSelection.length === 0) {
        this.$Message.warning("请选择要删除的资料");
        return;
      }
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除该资料？",
        content: "<p>删除后学生也将无法查看和导出。</p>",
        onOk: () => {
          this.deletenounx();
        }
      });
    },
    deletenounx() {
      // 删除多个选项
      const data = {
        ids: []
      };
      for (let e = 0; e < this.multipleSelection.length; e++) {
        data.ids.push(this.multipleSelection[e].id);
      }
      if (data.ids.length > 0) {
        data.ids = JSON.stringify(data.ids);
        this.$http.deleteNoun(data).then(res => {
          if (res.data.success) {
            this.$Message.success("删除成功");
            this.NounList1();
          }
        });
      } else {
        this.$Message.warning("请选择");
      }
    },
    show3(row) {
      this.ruleForm2 = {
        noun: row.noun,
        content: row.content,
        seq: row.seq
      };
      this.id = row.id;
      this.modal4 = true;
    },
    editorNoun() {
      // 修改专业名词
      this.$refs.noun.validate(valid => {
        if (valid) {
          const data = {
            id: this.id,
            content: this.ruleForm2.content,
            noun: this.ruleForm2.noun,
            seq: this.ruleForm2.seq,
            userCode: this.userCode
          };
          this.$http.createOrEditorNoun(data).then(res => {
            if (res.data.success) {
              this.$Message.success("修改成功");
              this.ruleForm2 = {
                content: "",
                noun: "",
                seq: 1
              };
              this.$forceUpdate();
              this.NounList();
            }
          });
        } else {
          this.$Message.error("请填写");
        }
      });
    },
    createlink() {
      // 添加网络连接
      this.$refs.link.validate(valid => {
        if (valid) {
          const data = {
            title: this.ruleForm3.title,
            link: this.ruleForm3.link,
            seq: this.ruleForm3.seq,
            userCode: this.userCode
          };
          this.$http.createOrEditorLink(data).then(res => {
            if (res.data.success) {
              this.$Message.success("创建成功");
              this.ruleForm3 = {
                title: "",
                link: "",
                seq: 1
              };
              this.$forceUpdate();
              this.LinkList();
            }
          });
        } else {
          this.$Message.error("请填写");
        }
      });
    },
    addlink() {
      this.ruleForm3 = {
        title: "",
        link: "",
        seq: 1
      };
      this.$forceUpdate();
      this.modal5 = true;
    },
    LinkList(x) {
      // 查询网络链接
      const pageNo = x || 1;
      const data = {
        pageSize: 10,
        pageNo,
        userId: this.$role.code
      };
      this.$http.LinkList(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.learnlink = res.data.data.list;
            this.linklength = res.data.data.list.length;
          }
          this.pageData3 = res.data.data;
        }
      });
    },
    LinkList1(x) {
      const pageNo = x || 1;
      const data = {
        pageSize: 10,
        pageNo,
        userId: this.$role.code
      };
      this.$http.LinkList(data).then(res => {
        if (res.data.success) {
          this.learnlink = res.data.data.list;
          this.linklength = res.data.data.list.length;
          this.pageData3 = res.data.data;
        }
      });
    },
    confirm3(row) {
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除该资料？",
        content: "<p>删除后学生也将无法查看和导出。</p>",
        onOk: () => {
          this.deletelink(row);
          this.$Message.success("删除成功");
        }
      });
    },
    deletelink(row) {
      // 删除网络链接数据（单个）
      const data = {
        ids: []
      };
      data.ids.push(row.id);
      data.ids = JSON.stringify(data.ids);
      //
      this.$http.deleteLink(data).then(res => {
        if (res.data.success) {
          this.LinkList1();
        }
      });
    },
    confirmLink() {
      if (this.multipleSelection.length === 0) {
        this.$Message.warning("请选择要删除的资料");
        return;
      }
      // 弹出确定删除模态框
      this.$Modal.confirm({
        title: "是否确定删除该资料？",
        content: "<p>删除后学生也将无法查看和导出。</p>",
        onOk: () => {
          this.deletelinkx();
        }
      });
    },
    deletelinkx() {
      // 删除多个选项
      const data = {
        ids: []
      };
      for (let e = 0; e < this.multipleSelection.length; e++) {
        data.ids.push(this.multipleSelection[e].id);
      }
      if (data.ids.length > 0) {
        data.ids = JSON.stringify(data.ids);
        this.$http.deleteLink(data).then(res => {
          if (res.data.success) {
            this.$Message.success("删除成功");
            this.LinkList1();
          }
        });
      } else {
        this.$Message.warning("请选择");
      }
    },
    show4(row) {
      this.ruleForm3 = {
        title: row.title,
        link: row.link,
        seq: row.seq
      };
      this.id = row.id;
      this.modal6 = true;
    },
    editorLink() {
      // 修改网络连接
      this.$refs.link.validate(valid => {
        if (valid) {
          const data = {
            id: this.id,
            title: this.ruleForm3.title,
            link: this.ruleForm3.link,
            seq: this.ruleForm3.seq,
            userCode: this.userCode
          };
          this.$http.createOrEditorLink(data).then(res => {
            if (res.data.success) {
              this.$Message.success("修改成功");
              this.ruleForm3 = {
                title: "",
                link: "",
                seq: 1
              };
              this.$forceUpdate();
              this.LinkList();
            }
          });
        } else {
          this.$Message.error("请填写");
        }
      });
    },
    getTeacherlist(params = {}) {
      // const data = {};
      // this.$http.listUser(data).then(res => {
      //   if (res.data.success) {
      //     // console.log(res.data.data);
      //     this.teacherlist = res.data.data.list;
      //   }
      // });
      const data = { queryParam: { ...params, role: 1 }, pageNo: 1, pageSize: 9999 };
      this.$http.getUserList(data).then(res => {
        if (res.data.success) {
          this.teacherlist = res.data.data.list;
        }
      });
    }
    // // 点击选择分享教师
    // chooseShareTeacher(item) {
    //   if (this.teacherSelect.indexOf(item.code) === -1) {
    //     this.teacherSelect.push(item.code);
    //     this.teacherSelectName.push(item.name);
    //     if (this.teacherSelect.length === this.teacherlist.length - 1) {
    //       this.allInCheck = true;
    //     }
    //   } else {
    //     this.teacherSelect.splice(this.teacherSelect.indexOf(item.code), 1);
    //     this.teacherSelectName.splice(this.teacherSelect.indexOf(item.code), 1);
    //     this.allInCheck = false;
    //   }
    // },
    // // 全选
    // allIn() {
    //   this.teacherSelect = [];
    //   this.teacherSelectName = [];
    //   this.allInCheck = !this.allInCheck;
    //   if (this.allInCheck === true) {
    //     this.teacherlist.forEach(res => {
    //       if (res.code !== this.$role.code) {
    //         this.teacherSelect.push(res.code);
    //         this.teacherSelectName.push(res.name);
    //       }
    //     });
    //   } else {
    //     this.teacherSelect = [];
    //     this.teacherSelectName = [];
    //   }
    // },
    // // 删除tag
    // delSelect(index) {
    //   this.teacherSelect.splice(index, 1);
    //   this.teacherSelectName.splice(index, 1);
    //   this.allInCheck = false;
    // },
    // // 关闭选择框
    // closeInput() {
    //   this.addTeachers = false;
    // }
  },
  watch: {
    modal7: {
      handler(newVal) {
        if (newVal === false) {
          // this.addTeachers = false;
          // this.teacherSelect = [];
          // this.teacherSelectName = [];
          // this.allInCheck = false;
          this.$refs.iSelectSearch.initValue();
        }
      }
    }
  },
  created() {
    this.nounlistlength();
    this.linklistlength();
    this.learnlistlength();
    this.getTeacherlist();
    this.learnlist(1);
    this.LinkList(1);
    this.NounList(1);
  }
};
</script>
<style lang="stylus">
.datacenter
  text-align left
  .ivu-table-wrapper
    border-color #EEF2F5
    .ivu-table:after
      background #EEF2F5
      z-index -99
    .ivu-table:before
      background-color #EEF2F5
    .ivu-table
      background #EEF2F5
      padding-bottom 2px
      font-size 14px
      thead
        tr
          th
            background #EEF2F5
            font-weight bolder
            color #000
      tbody
        tr
          td
            // text-align: center;
            // border-top 1px solid #b7b7b7
            border-collapse unset
            box-sizing border-box
            height 40px
            &:first-child
              // border-left 1px solid #b7b7b7
              border-radius 8px 0 0 8px
            &:last-child
              // border-right 1px solid #b7b7b7
              border-radius 0 8px 8px 0
          &:last-child
            td
              // border-bottom 1px solid #b7b7b7 !important
  .ivu-table-tip
    tr
      td
        &:last-child
          border-radius 8px 8px 8px 8px !important
  .ivu-page-item-active
    background #57A3F3
    a
      color #FFFFFF
  .RadioGroup
    display block
    text-align left
  .page
    margin-top 20px
    float right
  .dataNumber
    margin-top 25px
    margin-right 10px
    float right
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(153, 153, 153, 1)
.addTeacherstitle
  text-align right
  vertical-align middle
  text-align left
  font-size 14px
  color #515a6e
  line-height 1
  padding 10px 12px 16px 0
  -webkit-box-sizing border-box
  box-sizing border-box
.addTeachers
  width 488px
  border 1px solid #dcdee2
  border-radius 4px
  position relative
  z-index 1053
  // 这里是外框的上半部分
  .inputBlock
    .tagBox
      min-height 32px
      padding 0 24px 0 4px
      display block
      cursor pointer
      div
        .noSelect
          display block
          height 30px
          line-height 30px
          color #c5c8ce
          font-size 14px
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          padding-left 4px
          padding-right 22px
    .openDown
      position absolute
      top 50%
      right 8px
      line-height 1
      -webkit-transform translateY(-50%)
      transform translateY(-50%)
      font-size 14px
      color #808695
      -webkit-transition all 0.2s ease-in-out
      transition all 0.2s ease-in-out
      cursor pointer
  // 这里是选择教师部分
  .teachersList
    position absolute !important
    min-width 488px
    width inherit
    max-height 200px
    overflow auto
    margin 5px 0
    padding 5px 0
    background-color #fff
    -webkit-box-sizing border-box
    box-sizing border-box
    border-radius 4px
    -webkit-box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
    box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
    position absolute
    z-index 900
    .dropDownList
      min-width 100%
      list-style none
      box-sizing border-box
      margin 0
      padding 0
      -webkit-tap-highlight-color rgba(0, 0, 0, 0)
      .listChild
        position relative
        margin 0
        line-height normal
        padding 7px 16px
        clear both
        color #515a6e
        font-size 14px !important
        white-space nowrap
        list-style none
        cursor pointer
        -webkit-transition background 0.2s ease-in-out
        transition background 0.2s ease-in-out
        .ivu-icon-md-checkmark
          float right
          display none
      .listChild:hover
        background #F3F3F3
      .checkThisTeacher
        color rgba(45, 140, 240, 0.9)
        display initial !important
.mask
  position fixed
  overflow auto
  top 0
  right 0
  bottom 0
  left 0
  z-index 1052
  outline 0
</style>
